"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
var uuid_1 = require("uuid");
var store_1 = require("../store");
var functions_1 = require("../utils/functions");
var User = /** @class */ (function () {
    function User(options) {
        var _this = this;
        this.id = function (id) {
            var currentId = _this._store.get(_this.userIdKey);
            if (id !== undefined) {
                _this._store.set(_this.userIdKey, id);
                var changingIdentity = id !== currentId && currentId !== undefined && id !== null;
                if (changingIdentity) {
                    _this.anonymousId(null);
                }
            }
            return _this._store.get(_this.userIdKey);
        };
        this.anonymousId = function (id) {
            if (id === undefined) {
                var anonId = _this._store.get(_this.anonymousIdKey);
                if (anonId) {
                    return anonId;
                }
            }
            if (id === null) {
                _this._store.set(_this.anonymousIdKey, null);
                return _this._store.get(_this.anonymousIdKey);
            }
            _this._store.set(_this.anonymousIdKey, id !== null && id !== void 0 ? id : (0, uuid_1.v4)());
            return _this._store.get(_this.anonymousIdKey);
        };
        this.attributes = function (attributes) {
            if (attributes) {
                _this._store.set(_this.attributesKey, attributes !== null && attributes !== void 0 ? attributes : {});
            }
            return _this._store.get(_this.attributesKey) || {};
        };
        this.options = (0, functions_1.mergeDeep)(User.defaults, options);
        this.userIdKey = this.options.userIdKey;
        this.attributesKey = this.options.attributesKey;
        this.anonymousIdKey = this.options.anonymousIdKey;
        this._store = new store_1.CombinedStore(this.options.storeOptions);
    }
    Object.defineProperty(User, "defaults", {
        get: function () {
            return {
                storeOptions: store_1.CombinedStore.defaults,
                userIdKey: 's10_user_id',
                anonymousIdKey: 's10_anonymous_id',
                attributesKey: 's10_user_attributes',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "store", {
        get: function () {
            return this._store;
        },
        enumerable: false,
        configurable: true
    });
    User.prototype.identify = function (attributes, id) {
        attributes = attributes !== null && attributes !== void 0 ? attributes : {};
        var currentId = this.id();
        if (currentId === undefined || currentId === null || currentId === id) {
            attributes = __assign(__assign({}, this.attributes()), attributes);
        }
        if (id) {
            this.id(id);
        }
        this.attributes(attributes);
    };
    User.prototype.logout = function () {
        this.anonymousId(null);
        this.id(null);
        this.attributes({});
    };
    User.prototype.reset = function () {
        this.logout();
        this._store.remove(this.userIdKey);
        this._store.remove(this.anonymousIdKey);
    };
    User.prototype.load = function () {
        return new User(this.options);
    };
    User.prototype.save = function () {
        return true;
    };
    return User;
}());
exports.User = User;
//# sourceMappingURL=user.js.map